import { render, staticRenderFns } from "./ProcessedOrders.vue?vue&type=template&id=915f80ca&scoped=true"
import script from "./ProcessedOrders.vue?vue&type=script&lang=js"
export * from "./ProcessedOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915f80ca",
  null
  
)

export default component.exports